export const isMilestoneAchieved = (milestones, key) => {
  const milestone = milestones.find((item) => item.milestoneKey === key);

  return milestones.length > 0 && milestone !== undefined;
};
